import React from "react";
import "./CoupleTrip.css";
import ParisRomanticEscape from "../../assets/ParisRomanticEscape.png";
import MaldivesBeachGetaway from "../../assets/MaldivesBeachGetaway.png";
import SantoriniSunsetRetreat from "../../assets/SantoriniSunsetRetreat.png";
import VeniceGondolaExperience from "../../assets/VeniceGondolaExperience.png";
import BaliTropicalRomance from "../../assets/BaliTropicalRomance.png";
import SwissAlpsLoveJourney from "../../assets/SwissAlpsLoveJourney.png";
import { useNavigate } from "react-router-dom";
const coupleTrips = [
  {
    title: "Paris Romantic Escape",
    image: ParisRomanticEscape,
    description:
      "Experience magical moments in Paris with scenic river cruises, charming cafes, and iconic landmarks. Stroll hand in hand through beautiful streets, enjoy candlelight dinners, and create unforgettable memories together.",
    link: "/tour-package-data",
  },
  {
    title: "Maldives Beach Getaway",
    image: MaldivesBeachGetaway,
    description:
      "Relax in luxurious overwater villas surrounded by crystal clear waters in Maldives. Enjoy private beach dinners, sunset views, peaceful surroundings, and romantic experiences designed for couples seeking tranquility and connection.",
    link: "/tour-package-data",
  },
  {
    title: "Santorini Sunset Retreat",
    image: SantoriniSunsetRetreat,
    description:
      "Admire breathtaking sunsets over whitewashed buildings in Santorini. Explore charming villages, enjoy delicious cuisine, relax by scenic cliffs, and capture beautiful moments in this dreamy romantic destination.",
    link: "/tour-package-data",
  },
  {
    title: "Venice Gondola Experience",
    image: VeniceGondolaExperience,
    description:
      "Sail through picturesque canals of Venice on a classic gondola ride. Discover historic architecture, cozy restaurants, and enchanting evenings while sharing unforgettable experiences in this timeless romantic city.",
    link: "/tour-package-data",
  },
  {
    title: "Bali Tropical Romance",
    image: BaliTropicalRomance,
    description:
      "Enjoy serene beaches, lush landscapes, and peaceful resorts in Bali. Experience couple spa treatments, private villa stays, cultural tours, and romantic sunsets in this tropical paradise getaway.",
    link: "/tour-package-data",
  },
  {
    title: "Swiss Alps Love Journey",
    image: SwissAlpsLoveJourney,
    description:
      "Explore the majestic Swiss Alps with scenic train rides and snow covered peaks. Enjoy cozy mountain lodges, breathtaking views, peaceful walks, and intimate moments in this stunning romantic escape.",
    link: "/tour-package-data",
  },
];

const CoupleTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="couple-container">
      <h2 className="couple-title">Couple Trip Packages</h2>

      <div className="couple-grid">
        {coupleTrips.map((trip, index) => (
          <div
            className="couple-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="couple-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoupleTrip;
